var currentUrlArr = location.pathname.split("/");
var actor = currentUrlArr[1];
// モーダル
$(() => {
    // セレクトはaタグ無効
    $('.role').on('click', function(e){
        e.preventDefault();
    });

    // ロール変更
    $('.js-user-role').on('change', function() {
        // 元の値を取得
        let current = $(this).data('current');
        // ユーザーの権限一覧を取得
        let selected = $('.js-user-role option:selected').map(function(){
            return $(this).text();
        });
        // 権限に管理者がいなくなった場合は変更できないモーダルを出す
        if ($.inArray('管理者', selected) == -1) {
            // 権限を管理者に戻す
            $(this).val(9);
            $('#not_change_modal').modal('show');
            return false;
        } else {
        // 権限変更可能の場合は確認モーダルを出す
            // 元の選択値を取得
            $('#js-current').val(current);
            // 変更する選択値を取得
            $('#js-change_role').val($(this).val());
            // 変更するユーザー
            $('#js-user_id').val($(this).data('id'));
            $('#change_modal').modal('show');
        }
    });

    // モーダルを閉じる時の処理
    $('#change_modal').on('click', function () {
        let id = $('#js-user_id').val();
        let current = $('#js-current').val();
        // 変更前に戻す
        $('[data-id="' + id + '"]').val(current);

        $('#js-current').val('');
        $('#js-change_role').val('');
        $('#js-user_id').val('');
    });

    // 変更実行
    $('#js-change').on('click', function(e) {
        e.preventDefault();
        let id = $('#js-user_id').val();
        let role = $('#js-change_role').val();
        // 変更した選択値にselectedを付与
        $('[data-id="' + id + '"] option[value="'+role+'"]').prop('selected', true);
        // 元の選択値を上書き
        $('[data-id="' + id + '"]').data('current', role);
        // 権限変更
        $.ajax({
            url: '/'+actor+'/ajax/updateRole',
            type: 'POST',
            dataType : 'json',
            data: {
                user_id:id,
                role:role
            },
        }).done(function(data, textStatus, jqXHR) {
            return true;
        }).fail(function(jqXHR, textStatus, errorThrown ) {
            return false;
        }).always(function(){
            $('#change_modal').modal('hide');
        });
        $('#js-current').val('');
        $('#js-change_role').val('');
        $('#js-user_id').val('');
    });
});
